/* src/app/app.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/*# sourceMappingURL=app.component-4N53QXM6.css.map */
